import React, { useEffect, useState } from "react";

const CampaignCoupons = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const API_URL =
        "https://backend-coupon-distribution-nhf.onrender.com";

    useEffect(() => {
        fetchCampaignCoupons();
    }, []);

    const fetchCampaignCoupons = async () => {
        try {
            setLoading(true);
            setError("");

            const response = await fetch(
                `${API_URL}/get-campaign-coupons`
            );

            const result = await response.json();

            if (!response.ok) {
                throw new Error(
                    result.error || "Failed to fetch data"
                );
            }

            setData(result.data || []);
        } catch (err) {
            console.error(
                "Error fetching campaign coupons:",
                err
            );

            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div style={styles.container}>
                <h2>Campaign Coupons</h2>
                <p>Loading data...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div style={styles.container}>
                <h2>Campaign Coupons</h2>

                <p style={styles.error}>
                    ❌ {error}
                </p>

                <button
                    style={styles.refreshButton}
                    onClick={fetchCampaignCoupons}
                >
                    Retry
                </button>
            </div>
        );
    }

    const columns =
        data.length > 0
            ? Object.keys(data[0])
            : [];

    return (
        <div style={styles.container}>

            <div style={styles.header}>
                <div>
                    <h2 style={styles.title}>
                        Campaign Coupons
                    </h2>

                    <p style={styles.count}>
                        Total Records:{" "}
                        <strong>{data.length}</strong>
                    </p>
                </div>

                <button
                    style={styles.refreshButton}
                    onClick={fetchCampaignCoupons}
                >
                    Refresh
                </button>
            </div>

            {data.length === 0 ? (
                <div style={styles.noData}>
                    No records found.
                </div>
            ) : (
                <div style={styles.tableContainer}>
                    <table style={styles.table}>

                        <thead>
                            <tr>
                                {columns.map((column) => (
                                    <th
                                        key={column}
                                        style={styles.th}
                                    >
                                        {column}
                                    </th>
                                ))}
                            </tr>
                        </thead>

                        <tbody>
                            {data.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    {columns.map((column) => (
                                        <td
                                            key={column}
                                            style={styles.td}
                                        >
                                            {row[column] === null ||
                                            row[column] === undefined
                                                ? ""
                                                : String(row[column])}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>

                    </table>
                </div>
            )}
        </div>
    );
};

const styles = {
    container: {
        padding: "25px",
        width: "100%",
        boxSizing: "border-box",
        fontFamily: "Arial, sans-serif",
    },

    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "20px",
    },

    title: {
        margin: 0,
        fontSize: "24px",
    },

    count: {
        marginTop: "6px",
        color: "#666",
    },

    refreshButton: {
        padding: "10px 16px",
        border: "none",
        borderRadius: "6px",
        backgroundColor: "#1976d2",
        color: "white",
        cursor: "pointer",
        fontWeight: "bold",
    },

    tableContainer: {
        width: "100%",
        overflowX: "auto",
        overflowY: "auto",
        maxHeight: "70vh",
        border: "1px solid #ddd",
        borderRadius: "6px",
    },

    table: {
        width: "100%",
        borderCollapse: "collapse",
        minWidth: "800px",
    },

    th: {
        position: "sticky",
        top: 0,
        backgroundColor: "#f5f5f5",
        borderBottom: "2px solid #ddd",
        padding: "12px",
        textAlign: "left",
        whiteSpace: "nowrap",
        fontWeight: "bold",
        zIndex: 1,
    },

    td: {
        padding: "10px 12px",
        borderBottom: "1px solid #eee",
        whiteSpace: "nowrap",
    },

    noData: {
        padding: "40px",
        textAlign: "center",
        color: "#777",
        border: "1px solid #ddd",
        borderRadius: "6px",
    },

    error: {
        color: "red",
        marginBottom: "15px",
    },
};

export default CampaignCoupons;
